
import { mapState } from "vuex";

import { getVariantTitle } from "~/utils/shopify-utils";
import { tagableMixin, hideSearchOnOverlapMixin } from "~/mixins";

let DIMENSION = "60";

export default {
  mixins: [tagableMixin, hideSearchOnOverlapMixin],

  props: {
    image: { type: Object, default: () => {} },
    product: { type: Object, required: true },
    selectedVariant: { type: Object, default: () => {} },
  },

  computed: {
    ...mapState(["siteConfig"]),
    ...mapState("app", ["topBannerHeight"]),
    tags() {
      return this.product.tags ?? [];
    },
    imageOptions() {
      return {
        src: this.image.w_60_h_60,
        webpSrc: this.image.w_60_h_60_webp,
        alt: this.image.altText,
        widths: [DIMENSION],
        width: DIMENSION,
        height: DIMENSION,
      };
    },
    productTitle() {
      const variantTitle = getVariantTitle({
        variant: this.selectedVariant,
        isMultiVariant: this.isMultiVariant,
      });

      return `${this.product.title} ${variantTitle}`;
    },
    stickyHeaderPosition() {
      return this.$device.isMobile || this.isMobile
        ? { bottom: "0px" }
        : { top: `${this.topBannerHeight}px` };
    },
  },
};
